export default {
  header: {
    title: '資金記錄'
  },
  title: '交易賬號',
  deposit: {
    orderId: '訂單號',
    createdDate: '更新時間',
    tradeAccountNumber: '登錄賬號',
    amount: '存款金額',
    realAmount: '到賬金額',
    exchangeAmount: '換匯後入賬金額',
    status: '狀態',
    remark: '備註',
    noDeposit: '無存款記錄',
    fundBankType: '入金方式'
  },
  withdrawal: {
    orderId: '訂單號',
    createdDate: '更新時間',
    tradeAccountNumber: '登錄賬號',
    amount: '取款金額',
    status: '狀態',
    remark: '備註',
    noWithdrawal: '無取款記錄',
    fundBankType: '出金方式'
  },
  transfer: {
    orderId: '訂單號',
    createdDate: '更新時間',
    toTradeAccountNumber: '轉入賬戶',
    fromTradeAccountNumber: '轉出賬戶',
    amount: '申請金額',
    status: '狀態',
    realAmount: '實際轉賬金額',
    remark: '備註',
    noFund: '無內部轉賬記錄'
  },
  status: {
    completed: '完成',
    processing: '處理中',
    failure: '失敗',
    submitted: '已提交',
    checking: '已確認',
    canceled: '已撤銷',
    verified: '已提交',
    withdrawalcompleted: '已處理',
    withdrawn: '被退回'
  },
  errorTips: {
    unprocessedData: '還有未處理的提交'
  },
  export: '導出', // 補充
  chooseTime: '請選擇時間',
  exchange: {
    orderId: '訂單號',
    createdDate: '申請時間',
    tradeAccountNumber: '登錄賬號',
    amount: '申請換匯金額',
    lockWay: '鎖定方向',
    realAmount: '實際換匯金額	',
    realExchangeRate: '實際匯率',
    status: '狀態',
    remark: '備註',
    noFund: '無換匯記錄'
  }
}
